<script>
    import { onMount } from "svelte";
    export let start;
    export let end;
    export let onChange;

    onMount(() => {

        const calendarElement = document.getElementById('calendar');
        const calendar = new FullCalendar.Calendar(calendarElement, {
            weekNumberCalculation: 'ISO',
            initialView: 'dayGridMonth',
            aspectRatio: 1,
            selectable: true,
            firstDay: 1,
            select: (info) => {
                start = info.startStr;
                end = info.endStr;
                onChange();
            }
            
            // HORAS DE TRABAJO --> https://fullcalendar.io/docs/business-hours
        });

        calendar.render();

    });

</script>

<div class="calContainer">
    <div id="calendar"></div>
</div>

<style>

.calContainer {
    width: 350px;
    padding: 1%;
    border: 1px solid #d9d9d9;
    border-radius: 3%;
    font-size: 0.65rem !important;
    position: absolute;
    background-color: white;
}

</style>